import { useMutation } from "@tanstack/react-query";
import {
  upsertChemistryResult,
  type ChemistryResultPayload,
} from "../../repositories/lab-de.repositories";

export const useSaveChemistryResultMutation = () => {
  return useMutation({
    mutationFn: async (payload: ChemistryResultPayload) => {
      const resp = await upsertChemistryResult(payload);
      if (!resp.ok)
        throw new Error(resp.message ?? "Failed to save chemistry result");
      return resp;
    },
  });
};
